<template>
  <div style="padding:14px 10px">
    <!-- 面包屑导航 -->
    <div class="cur_route">{{ $route.name }}</div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/index' }">Dashboard</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.id" placeholder="Id" clearable style="width:100px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-cascader :options="country_business" size="small"
          :props="{ checkStrictly: true, value: 'name', label: 'name', expandTrigger: 'hover' }" clearable
          placeholder="Country/Business" @change="cascaderChange" style="position:relative;right:2px">
        </el-cascader>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.amount" placeholder="Amount" clearable style="width:100px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.paid_phone" placeholder="Paid phone" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.trans_id" placeholder="Trans id" clearable style="width:100px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.transaction_id" placeholder="Transaction id" clearable
          style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.refund_transaction_id" placeholder="Refund transaction id" clearable
          style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.add_time" type="daterange" size="small" value-format="yyyy-MM-dd" align="right"
          unlink-panels start-placeholder="Start date" end-placeholder="End date" :picker-options="pickerOptions"
          clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button type="success" size="small" icon="el-icon-document" @click="exportExcel">Export</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 1552px;">
      <el-table-column prop="id" label="Id" width="70" align="center">
      </el-table-column>
      <el-table-column prop="card_number" label="Number" width="90" align="center">
      </el-table-column>
      <el-table-column prop="card_name" label="Name" width="160" align="center">
      </el-table-column>
      <el-table-column prop="amount" label="Amount" width="80">
      </el-table-column>
      <el-table-column prop="paid_phone" label="Paid phone" width="100">
      </el-table-column>
      <el-table-column prop="business_name" label="Business" width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.business_name }}</div>
          <div v-if="scope.row.trans_id != '0'">{{ scope.row.trans_id }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="message_id" label="Sms" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.message_id">{{ scope.row.message_id }}</div>
          <div v-if="scope.row.transaction_id">{{ scope.row.transaction_id }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="refund_message_id" label="Sms refund" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.refund_message_id">{{ scope.row.refund_message_id }}</div>
          <div v-if="scope.row.refund_transaction_id">{{ scope.row.refund_transaction_id }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="operator_name" label="Operator name" width="140" align="center">
      </el-table-column>
      <el-table-column prop="business_country" label="Country" width="90">
      </el-table-column>
      <el-table-column prop="add_time" label="Add time" width="140">
        <template slot-scope="scope">
          <div>{{ scope.row.add_time | timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="Action" width="140" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="seeDetail(scope.row)"
            v-if="scope.row.message_id == 0">success</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- successWithdraw界面 -->
    <el-dialog title="" :visible.sync="detailVisible" @click='closeDialog("detail")' width="40%">
      <el-descriptions title="Success Withdraw" :column="2" border style="padding-bottom:20px">
        <el-descriptions-item label="Trans Id">{{ detail_info.trans_id }}</el-descriptions-item>
        <el-descriptions-item label="Paid Phone">{{ detail_info.paid_phone }}</el-descriptions-item>
        <el-descriptions-item label="Amount">{{ detail_info.amount }}</el-descriptions-item>
        <el-descriptions-item label="Add time">{{ detail_info.add_time | timestampToTime }}</el-descriptions-item>
        <el-descriptions-item label="Transaction Id">
          <el-input type="text" size="small" v-model="transaction_id" placeholder="输入Transaction Id" clearable
            style="width:200px">
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item label="Trans Time">
          <el-date-picker size="small" v-model="trans_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="Trans Time" clearable>
          </el-date-picker>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <div style="font-size:12px;margin-bottom:10px;color:#F56C6C">(tips：After confirmation, the system will add a
          message and will automatically call back after 3 minutes.)</div>
        <el-button size="small" type="primary" :loading="loading" class="title"
          @click="reservedSucc(detail_info.id)">Confirm
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  reservedList,
  getCountryBusiness,
  reservedSucc,
} from '../../api/apiFun'
import {
  timestampToTime,
  exportUrl,
  cascaderChange,
} from '@/utils/util';
import Pagination from '../../components/Pagination'
let that = ""
export default {
  data() {
    return {
      title: '',
      loading: false, //是显示加载
      params: {
        page: 1,
        limit: 10,
        id: '',
        paid_phone: '',
        trans_id: '',
        transaction_id: '',
        refund_transaction_id: '',
        add_time: '',
        confirm_time: '',
        add_time: '',
        business_name: '',
        amount: '',
        country: ''
      },
      business_list: [],
      listData: [], //User数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      pickerOptions: {
        shortcuts: [{
          text: 'Today',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last week',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last month',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      detailVisible: false,
      detail_info: {},
      transaction_id: '',
      trans_time: '',
      examineInfo: {},
      editFormVisible: false,
      editForm: {
        business_id: '',
        amount: '',
        phone: 0,
      },
      rules: {
        business_id: [{
          required: true,
          message: 'Please select business',
          trigger: 'blur'
        }],
        amount: [{
          required: true,
          message: 'Amount',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: 'Please enter phone number',
          trigger: 'blur'
        }],
      },
      rateVisible: false,
      country_business: []
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  filters: {
    timestampToTime: function (timestamp) {
      return timestampToTime(timestamp)
    },
  },
  created() {
    that = this
    this.getdata(this.params)
    this.getCountryBusiness()
  },
  methods: {
    reservedSucc(id) {
      if (!this.transaction_id) {
        this.$message.error('Please enter Transaction Id')
        return
      }
      if (!this.trans_time) {
        this.$message.error('Please enter Trans Time')
        return
      }
      this.$confirm('确定要完成代收单吗?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.loading = true
        reservedSucc({
          id: id,
          transaction_id: this.transaction_id,
          trans_time: this.trans_time,
        }).then(res => {
          this.loading = false
          this.detailVisible = false
          if (res.code == 200) {
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'Successful reserved'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.detailVisible = false
          this.loading = false
          this.$message.error('Failed, please try again later!')
        })
      }).catch(() => {

      })
    },
    seeDetail(detail_info) {
      if (detail_info.message_id > 0) {
        this.$message.error('Cannot perform the operation！')
        return
      }
      this.detailVisible = true
      this.detail_info = detail_info
    },
    getCountryBusiness() {
      getCountryBusiness().then(res => {
        if (res.code == 400) {
          this.$message({
            state: 'info',
            message: res.msg
          })
        } else {
          this.country_business = res.datas;
        }
      }).catch(err => {
        this.$message.error('Failed to obtain business list, please try again later!')
      })
    },
    cascaderChange(value) {
      var cascader = cascaderChange(value)
      this.params.country = cascader[0]
      this.params.business_name = cascader[1]
    },
    exportExcel() {
      window.location.href = exportUrl('/admin/reserved/export_reserved', this.params);
    },

    closeDialog(type) {
      if (type == 'detail') {
        this.detailVisible = false
      }
      if (type == 'rate') {
        this.rateVisible = false
      }
    },
    // 获取Recharge
    getdata(parameter) {
      if (parameter.add_time == null) {
        parameter.add_time = ''
      }
      if (parameter.add_time == null) {
        parameter.add_time = ''
      }
      this.loading = true
      reservedList(parameter).then(res => {
        this.loading = false
        if (res.code == 400) {
          this.$message({
            state: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.datas.list
          // 分页赋值
          this.pageparm.currentPage = this.params.page
          this.pageparm.pageSize = this.params.limit
          this.pageparm.total = res.datas.count
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('Failed, please try again later!')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.params.page = parm.currentPage
      this.params.limit = parm.pageSize
      this.getdata(this.params)
    },
    // Search事件
    search() {
      this.params.page = 1
      this.getdata(this.params)
    },
  }
}

</script>

<style scoped>
.el-image__error {
  font-size: 12px !important;
}

.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/transaction/reserved.vue